import type { TourConfig } from './types';

export const foodsTour: TourConfig = {
  id: 'foods-page',
  name: 'Food Database Tour',
  description: 'Learn how to manage your food database',
  requiredPath: '/dashboard/food-database',
  steps: [
    {
      element: '[data-tour="foods-header"]',
      popover: {
        title: 'Food Database',
        description:
          'This is your master nutrition library. Add foods with their nutritional information to use in diet plans.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="foods-add-button"]',
      popover: {
        title: 'Add New Food',
        description:
          'Add a new food item with calories, protein, carbs, fat, and fiber information.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="foods-search"]',
      popover: {
        title: 'Search Foods',
        description:
          'Quickly search for foods by name. Check if a food exists before adding duplicates.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="foods-table"]',
      popover: {
        title: 'Food List',
        description:
          'View all your foods with their nutritional values. Click on the actions menu to view, edit, or delete.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
